var toggleButtonn = document.querySelector('.disclosure__button');
var allCountryListt = document.querySelector('.disclosure__list-wrapper.country-selector');

// Toggle dropdown on button click
toggleButtonn.addEventListener('click', (event) => {
  event.stopPropagation(); // Prevent event from bubbling to document
  toggleButtonn.classList.toggle('open');

  if (toggleButtonn.classList.contains('open')) {
    openCurrenyDropdown();
  } else {
    closeCurrencyDropdown();
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', () => {
  if (toggleButtonn.classList.contains('open')) {
    closeCurrencyDropdown();
    toggleButtonn.classList.remove('open');
  }
});

function openCurrenyDropdown() {
  allCountryListt.style.visibility = 'visible';
  allCountryListt.classList.add('open');
}

function closeCurrencyDropdown() {
  allCountryListt.classList.remove('open');
  setTimeout(() => {
    if (!allCountryListt.classList.contains('open')) {
      allCountryListt.style.visibility = 'hidden';
    }
  }, 300);
}